"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarDay = void 0;

var _styledComponents = require("styled-components");

var CalendarDayToday = (0, _styledComponents.css)(["&--today{position:relative;&:before{content:'\u0421\u0435\u0433\u043E\u0434\u043D\u044F';position:absolute;font-size:9px;line-height:12px;top:2px;left:0;right:0;font-weight:400;}}"]);
var CalendarDayDisabled = (0, _styledComponents.css)(["&--disabled{background:repeating-linear-gradient( -45deg,#e6e9ee,#e6e9ee 1px,#ffffff 1px,#ffffff 2px );}"]);
var CalendarDaySelected = (0, _styledComponents.css)(["&--selected{background-color:", ";color:#fff;&:hover{background-color:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blue;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.brightBlue;
});
var CalendarDayHighlighted = (0, _styledComponents.css)([""]);
var CalendarDay = (0, _styledComponents.css)([".react-datepicker__day{width:48px;height:48px;border-radius:0;margin:0;padding:13px 0;outline:none;color:", ";font-size:16px;line-height:20px;", " &:hover{background-color:", ";}&--keyboard-selected{background-color:", ";}", " ", " ", " ", " &--outside-month{opacity:0.3;background:none;pointer-events:none;}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackBase;
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile && "\n      width: 44px;\n      height: 44px;\n      padding: 11px 0;\n    ";
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.solitude;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.solitude;
}, CalendarDaySelected, CalendarDayToday, CalendarDayDisabled, CalendarDayHighlighted);
exports.CalendarDay = CalendarDay;